import React from 'react'
import SbEditable from 'storyblok-react'
import cx from 'classnames'

import Image from './../Image'
import TextRenderer from './../TextRenderer'

import styles from './styles.module.scss'

const TestimonialItem = (props) => {
	
	const containerClasses = cx({
		'container': true,
		[styles['testimonial-item__container']]: true,
		[styles['testimonial-item__container--center']]: props.blok.text_align == 'center',
		[styles['testimonial-item__container--right']]: props.blok.text_align == 'right',
	})
	
	const imageClasses = cx({
		[styles['testimonial-item__image-wrapper']]: true,
		[styles['testimonial-item__image-wrapper--left']]: props.blok.image_position == 'left',
		[styles['testimonial-item__image-wrapper--right']]: props.blok.image_position == 'right'
	})

	return (
		<SbEditable content={props.blok}>
			<div className={`${styles['testimonial-item']} ${props.className}`} style={{ backgroundColor: props.blok.background_color }}>
				<div className={containerClasses}>
					<div className={styles['testimonial-item__content']} style={{ color: props.blok.text_color }}>
						<TextRenderer className={styles['testimonial-item__description']} text={props.blok.description} />
						<p className={`body ${styles['testimonial-item__name']}`}>{props.blok.name}</p>
					</div>
					<div className={styles['testimonial-item__image-overlay']} style={{ backgroundColor: props.blok.overlay_color, opacity: props.blok.overlay_amount / 100 }}></div>
					{props.blok.image.filename && (
						<figure className={imageClasses}>
							<img 
								className={styles['testimonial-item__image']}
								src={props.blok.image.filename}
								alt={props.blok.image.alt}
							/>
						</figure>
					)}
				</div>
            </div>
		</SbEditable>
	)
}

export default TestimonialItem